<template>
  <div>
   <!-- route path: {{ $route.path }} ==== -->
  <!-- <pre>
    dataTableItems {{ dataTableItems }}
  </pre> -->
    <div
      class="flex justify-start  w-full items-center  mb-2 pr-2 space-x-4 py-1"
    >
      <div
        class="w-full bg-rounded-md flex items-center justify-start border-2 rounded-md border-black pl-2"
      >
        <img src="/icons/search.png" alt="magnify" class="w-[24px] pr-2" />
        <input
          type="text"
          v-model="search"
          placeholder="Search"
          class="py-1 w-full pl-2 outline-none rounded-md"
        />
      </div>
      <div><v-btn @click="refresh">Refresh Table</v-btn></div>
    </div>
    <div class="md:flex menuWrapper">
      <div class="w-full">
        <div v-if="progressBar">
          <v-progress-linear
            :value="progressValue"
            color="green"
            height="6"
            rounded
          ></v-progress-linear>
          <div class="text-xs text-right" style="color: #000;">
            {{ Math.round(progressValue) }}%
          </div>
        </div>
        <v-data-table
          class="no-data-table-rows-hover w-full"
          hide-default-header
          dense
          :headers="headers"
          :items="dataTableItems"
          :search="isClosedTickets ? '' : search"
          :server-items-length="isClosedTickets ? closedTicketsTotal : undefined"
          :options.sync="tableOptions"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
          @update:options="onTableOptionsUpdate"
        >
          <template v-slot:header>
            <thead>
              <tr>
                <th class="bg-[#44546A] text-left px-4 py-2 textStyle">Row</th>
                <th
                  class="bg-[#44546A] text-left px-4 py-2 textStyle"
                  style="width: 150px;"
                >
                  Ticket No.
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">Date</th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Buyer
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Classification
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Subject
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Contract No.
                </th>
                <th
                  v-if="$route.path.includes('/updated-bis')"
                  class="textStyle bg-[#44546A] text-left px-4 py-2"
                >
                  Attachments
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Action
                </th>
              </tr>
            </thead>
          </template>
          <!-- Custom Item Slot -->
          <template v-slot:item="{ item }">
            <tr
              :class="[
                item.is_read === 0
                  ? ''
                  : $route.path.includes('/unassigned-tickets')
                  ? 'text-black font-extrabold'
                  : '',
                markedRows.includes(item.ticket_id) ? '' : '',
              ]"
            >
              <td class="align-top px-4 py-2">
                <div class="flex items-center justify-start space-x-2">
                  <div
                    :class="
                      markedRows.includes(item.ticket_id)
                        ? 'marked-circle'
                        : 'unmarked-circle'
                    "
                    class="rounded-full w-4 h-4 flex items-center justify-center"
                  >
                    <span class="text-xl">&bull;</span>
                  </div>
                  <div>
                    <v-btn
                      v-if="$route.path.includes('/unassigned-tickets')"
                      @click="checkTicketId(item)"
                    >
                      {{ item.ticket_id }}</v-btn
                    >
                    <div v-else>{{ item.ticket_id }}</div>
                  </div>
                </div>
              </td>

              <td class="align-top px-4 py-2" style="width: 150px;">
                {{ item.moldex_ticket_number }}
              </td>
              <td class="align-top px-4 py-2">{{ formatToPhTime(item.reg_date) }}</td>
              <td class="align-top px-4 py-2">{{ item.buyer_name }}</td>
              <td class="align-top px-4 py-2">{{ item.classification }}</td>
              <td class="align-top px-4 py-2">{{ item.subject }}</td>
              <td class="align-top px-4 py-2">{{ item.contract_number }}</td>
              <td
                v-if="$route.path.includes('/updated-bis')"
                class="align-top px-4 py-2"
              >
                <div
                  v-if="
                    item.attachments.attachment1 ||
                      item.attachments.attachment2 ||
                      item.attachments.attachment3
                  "
                >
                  <v-btn small @click="viewAttachment(item)">Attachments</v-btn>
                </div>
                <div v-else>
                  none
                </div>
              </td>
              <td class="align-top px-4 py-2 space-y-1">
                <button
                  v-if="
                    !$route.path.includes('/closed-bis') &&
                      !$route.path.includes('/closed-tickets')
                  "
                  :class="buttonStyle"
                  @click="toggleMarkAsUnread(item.ticket_id)"
                >
                  {{
                    markedRows.includes(item.ticket_id)
                      ? "Mark as read"
                      : "Mark as unread"
                  }}
                </button>
                <button :class="buttonStyle" @click="openSelectedRow(item)">
                  View Ticket
                </button>
                <!-- <button :class="buttonStyle" @click="openToAssign(item)">
                  Assign
                </button> -->
                <button
                  v-if="$route.meta.id != 12"
                  :class="buttonStyle"
                  @click.stop="openDialogCloseTicket(item)"
                >
                  Close Ticket
                </button>
                <button v-else :class="buttonStyle" @click="reOpenTicket(item)">
                  Reopen Ticket
                </button>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
    <TicketDialog
      v-if="$route.path.includes('/unassigned-tickets')"
      @closeDialog="closeDialog"
      :selectedItemInfo="selectedItemInfo"
      :showDialog="showDialog"
      :notification_history="notification_history"
      :csvInfo="csvInfo"
      :classification_id="classification_id"
    />
    <TicketDialog
      v-if="$route.path.includes('/closed-tickets')"
      @closeDialog="closeDialog"
      :selectedItemInfo="selectedItemInfo"
      :showDialog="showDialog"
      :notification_history="notification_history"
      :csvInfo="csvInfo"
      :classification_id="classification_id"
    />
    <TicketDialogBis
      v-if="$route.path.includes('/updated-bis')"
      @closeDialog="closeDialog"
      :selectedItemInfo="selectedItemInfo"
      :showDialog="showDialog"
      :csvInfo="csvInfo"
      :notification_history="notification_history"
      :classification_id="classification_id"
    />
    <TicketDialogBis
      v-if="$route.path.includes('/closed-bis')"
      @closeDialog="closeDialog"
      :selectedItemInfo="selectedItemInfo"
      :showDialog="showDialog"
      :notification_history="notification_history"
      :classification_id="classification_id"
    />

    <div>
      <AssignDialog
        class="bg-white"
        :openAssignDialog="openAssignDialog"
        @assignSubmitted="assignSubmitted"
        @closeAssignDialog="closeAssignDialog"
      />
    </div>
    <v-dialog
      v-model="viewAttachmentDialog"
      :overlay="false"
      max-width="800px"
      transition="dialog-transition"
    >
      <BisAttachment
        :selectedAttachments="selectedAttachments"
        @closeAttachmentDialog="closeAttachmentDialog"
      />
    </v-dialog>
    <v-dialog
      v-if="$route.meta.title != 'Closed Tickets'"
      v-model="dialogCloseTicket"
      persistent
      :overlay="true"
      max-width="400px"
      transition="dialog-transition"
    >
      <v-card class="p-2">
        <v-card-title primary-title>
          Notice
        </v-card-title>
        <v-card-text> Close ticket id:{{ ticketIdToClose }}? </v-card-text>
        <v-card-actions class="mx-4">
          <v-btn @click="cancelCloseTicket">Cancel</v-btn>
          <v-btn @click="closeTicket(selectedItemInfo)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AssignDialog from "../components/AssignDialog.vue";
import axios from "axios";
import TicketDialog from "../components/TicketDialog.vue";
import TicketDialogBis from "../components/TicketDialogBis.vue";
import BisAttachment from "../components/BisAttachmentsPage.vue";
import 'moment-timezone';

export default {
  props: ["keySearch"],
  components: { AssignDialog, TicketDialog, TicketDialogBis, BisAttachment },
  data() {
    return {
      ticketIdToClose: null,
      isUnread: false,
      selectedAttachments: [],
      markedRows: [],
      buttonStyle:
        "bg-gray-200 rounded-md px-4 w-full hover:bg-[#44546A] hover:text-white",
      progressBar: false,
      csvInfo: [],
      classification_id: "",
      notification_history: [],
      dialogCloseTicket: false,
      viewAttachmentDialog: false,
      viewAttachmentUrl: "",
      selectedItemInfo: {},
      ticket_id_selected: null,
      search: "",
      openAssignDialog: false,
      showDialog: false,
      dataTableItems: [],
      closedTicketsTotal: 0,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      closedSearchTimer: null,
          // Progress
          progressValue: 0,
          progressTimer: null,
      headers: [
        {
          text: "Row",
          value: "ticket_id",
          class: "thead1",
        },
        {
          text: "Ticket No.",
          value: "moldex_ticket_number",
          class: "thead1",
        },
        {
          text: "Date",
          value: "reg_date",
          class: "thead1",
        },
        {
          text: "Buyer",
          value: "buyer_name",
          class: "thead1",
        },
        {
          text: "Classification",
          value: "classification",
          class: "thead1",
        },
        {
          text: "Subject",
          value: "subject",
          class: "thead1",
        },

        {
          text: "Contract No.",
          value: "contract_number",
          class: "thead1",
        },
        // {
        //   text: "Ticket Location",
        //   value: "location",
        //   class: "thead1",
        // },
        {
          text: "Attachments",
          value: "attachments",
          class: "thead1",
        },
        {
          text: "Action",
          value: "actions",
          class: "thead1",
        },
      ],
    };
  },

  computed: {
    serverUrl() {
      return this.axios.defaults.baseURL;
    },
    isClosedTickets() {
      return this.$route.path.includes("/closed-tickets");
    },
  },
  watch: {
    "$route.meta.id": {
      immediate: true,
      async handler(e) {
        if (e == 0) {
          this.getTickets();
        } else if (e == 10) {
          this.getBISTickets();
        } else if (e == 12) {
          this.tableOptions.page = 1;
          this.getClosedTickets();
        } else if (e == 99) {
          this.getWatchList();
        } else if (e == 100) {
          this.getClosedBis();
        } else {
          this.postTickets(e);
        }
      },
    },
    search() {
      if (!this.isClosedTickets) return;
      clearTimeout(this.closedSearchTimer);
      this.closedSearchTimer = setTimeout(() => {
        if (this.tableOptions.page !== 1) {
          this.tableOptions.page = 1;
        } else {
          this.getClosedTickets();
        }
      }, 400);
    },
  },
  mounted() {},
  methods: {
    onTableOptionsUpdate() {
      if (this.isClosedTickets) {
        this.getClosedTickets();
      }
    },
    startProgress() {
      this.progressBar = true;
      this.progressValue = 0;
      if (this.progressTimer) clearInterval(this.progressTimer);
      this.progressTimer = setInterval(() => {
        if (this.progressValue < 90) {
          this.progressValue += Math.random() * 7 + 3;
          if (this.progressValue > 90) this.progressValue = 90;
        }
      }, 200);
    },
    endProgress() {
      this.progressValue = 100;
      if (this.progressTimer) {
        clearInterval(this.progressTimer);
        this.progressTimer = null;
      }
      setTimeout(() => {
        this.progressBar = false;
        this.progressValue = 0;
      }, 300);
    },
    toggleMarkAsUnread(rowId) {
      const ticket = this.dataTableItems.find(
        (item) => item.ticket_id === rowId
      );

      // Toggle the is_read status
      ticket.is_read = ticket.is_read ? 0 : 1;

      // Update the markedRows array based on the is_read status
      if (ticket.is_read) {
        // If the ticket is marked as read (1), add it to markedRows
        this.markedRows.push(rowId);
      } else {
        // If the ticket is marked as unread (0), remove it from markedRows
        this.markedRows = this.markedRows.filter((id) => id !== rowId);
      }

      // Update the backend to reflect the new is_read status
      this.updateReadStatus(rowId, ticket.is_read);
    },

    refresh() {
      this.search = "";
      const route_name = this.$route.name;
      if (route_name == "unassigned-tickets") {
        this.getTickets();
      } else if (route_name == "closed-tickets") {
        this.getClosedTickets();
      } else if (route_name == "updated-bis") {
        this.getBISTickets();
      } else if (route_name == "closed-bis") {
        this.getClosedBis();
      } else if (route_name == "watch-list") {
        this.getWatchList();
      }
      this.$toast.success("Table refreshed successfully!");
    },
    closeAttachmentDialog() {
      this.viewAttachmentDialog = false;
    },
    async updateReadStatus(ticketId, isRead) {
      try {
        await axios.post("/tickets/update-status", {
          ticketId: ticketId,
          is_read: isRead,
        });
      } catch (error) {
        console.error("Error updating read status:", error);
      }
    },

    async checkTicketId(item) {
      const data = {
        ticket_id: item.ticket_id,
      };
      axios
        .post("/tickets/checkForMissingCt", data)
        .then(async (res) => {
          if (res.data.status) {
            this.getTickets();
            alert(res.data.message);
          } else {
            alert(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // async checkTicketsForEmpty() {
    //   await axios.get("/tickets/check_tickets");
    // },

    // function to separate base from path
    separateUrl(fullUrl) {
      // Splitting the URL to handle the case of double slashes after the domain
      const parts = fullUrl.split("//", 3); // Split into at most 3 parts

      let baseUrl, path;
      if (parts.length === 3) {
        // If there are exactly 3 parts, it means there was a double slash
        baseUrl = parts[0] + "//" + parts[1]; // Combine the first two parts to form the base URL
        path = "/" + parts[2]; // The third part is the path, ensure it starts with a slash
      } else {
        // If the URL doesn't have double slashes, return it as is
        baseUrl = fullUrl;
        path = "";
      }

      return { baseUrl, path };
    },
    viewAttachment(item) {
      this.selectedAttachments = [
        item.attachments.attachment1,
        item.attachments.attachment2,
        item.attachments.attachment3,
      ].filter(Boolean); // Filter out any undefined/null values
      this.viewAttachmentDialog = true;
    },

    // closeTicket(item) {
    //   // Close all other dialogs first
    //   this.showDialog = false;
    //   this.viewAttachmentDialog = false;
    //   this.openAssignDialog = false;

    //   // Then open the close ticket dialog
    //   this.dialogCloseTicket = true;
    //   this.selectedItemInfo = item;
    // },
    cancelCloseTicket() {
      this.ticketIdToClose = null;
      this.dialogCloseTicket = false;
    },
    openDialogCloseTicket(item) {
      this.dialogCloseTicket = true;
      this.ticketIdToClose = item.ticket_id;
    },

    closeTicket() {
      let data = {
        ticket_id: this.ticketIdToClose,
      };

      axios
        .post("/tickets/ticket-closed", data)
        .then(() => {
          // Only after successful API call, clean up the state
          this.selectedItemInfo = null;
          this.showDialog = false;
          this.viewAttachmentDialog = false;
          this.openAssignDialog = false;
          this.dialogCloseTicket = false;

          // Refresh the table data
          this.getTickets();
        })
        .catch((err) => {
          console.error("Error closing ticket:", err);
          alert("Failed to close ticket. Please try again.");
        });
    },

    formatToPhTime(d) {
        if (!d) return '';

        try {
            // Vultr Postgres returns ISO like "2026-08-22T03:40:05.907Z"
            // (Supabase often used "+00:00" + 6-digit micros). Parse via Date.
            const parsed = new Date(d);
            if (isNaN(parsed.getTime())) {
                console.error('Invalid date format:', d);
                return '';
            }

            // Wall-clock components in UTC (matches prior Supabase display base)
            const year = parsed.getUTCFullYear();
            const month = parsed.getUTCMonth();
            const day = parsed.getUTCDate();
            const hour = parsed.getUTCHours();
            const minute = parsed.getUTCMinutes();
            const second = parsed.getUTCSeconds();

            const displayDate = new Date(year, month, day, hour, minute, second);

            // Post March 16, 2025: treat stored UTC as UTC and show PH (+8)
            const migrationDate = new Date(2025, 2, 16);
            if (displayDate >= migrationDate) {
                displayDate.setHours(displayDate.getHours() + 8);
            }

            return displayDate.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            });
        } catch (error) {
            console.error('Date conversion error for:', d, error);
            return '';
        }
    },
    assignSubmitted(item) {
      this.openAssignDialog = false;
      let data = {
        department_id: item,
        ticket_id: this.ticket_id_selected,
      };
      axios
        .post("/tickets/ticket-assignment", data)
        .then((res) => {
          alert(res.data.message);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    reOpenTicket(item) {
      let data = {
        ticket_id: item.ticket_id,
      };
      axios
        .post("/tickets/ticket-reopen", data)
        .then(() => {
          this.dialogCloseTicket = false;
          alert(
            "The ticket " + item.ticket_id + " has been successfully reopened."
          );
          this.getClosedTickets();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    closeAssignDialog() {
      this.openAssignDialog = false;
    },
    closeDialog() {
      this.showDialog = false;
      this.selectedItemInfo = {};
    },
    openToAssign(item) {
      this.openAssignDialog = true;
      this.ticket_id_selected = item.ticket_id;
    },

    async getCsvInfo(customerCode, contractNumber) {
      try {
        const info = {
          customer_code: customerCode,
          contract_number: contractNumber,
        };
        const res = await axios.post("/cs_data/get-contract-info", info);
        this.csvInfo = Array.isArray(res.data) ? res.data : []; // Ensure it's an array
      } catch (error) {
        console.error("Error fetching CSV Info:", error);
        this.csvInfo = []; // Fallback to an empty array on error
      }
    },
    async openSelectedRow(selected_row) {
      this.startProgress();
      this.selectedItemInfo = selected_row;
      this.classification_id = selected_row.classification_id;

      this.getNotificationHistory(selected_row.ticket_id);
      await this.getCsvInfo(
        selected_row.customer_code,
        selected_row.contract_number
      );
      this.endProgress();
      this.showDialog = true;
    },
    getNotificationHistory(ticket_id) {
      let data = {
        ticket_id: ticket_id,
      };
      axios.post("/history/get", data).then((res) => {
        this.notification_history = res.data;
      });
    },
    getClosedTickets() {
      this.startProgress();
      const page = this.tableOptions.page || 1;
      const limit = this.tableOptions.itemsPerPage || 10;
      const params = { page, limit };
      if (this.search && this.search.trim()) {
        params.search = this.search.trim();
      }
      axios
        .get("/tickets/getClosedTickets", { params })
        .then((res) => {
          const payload = res.data;
          if (payload && Array.isArray(payload.items)) {
            this.dataTableItems = payload.items;
            this.closedTicketsTotal = payload.total || 0;
          } else if (Array.isArray(payload)) {
            this.dataTableItems = payload;
            this.closedTicketsTotal = payload.length;
          } else {
            this.dataTableItems = [];
            this.closedTicketsTotal = 0;
          }
          this.endProgress();
        })
        .catch(() => this.endProgress());
    },
    getClosedBis() {
      this.startProgress();
      axios.get("/tickets/getClosedBis").then((res) => {
        this.dataTableItems = res.data;
        this.endProgress();
      }).catch(() => this.endProgress());
    },
    async getBISTickets() {
      this.startProgress();
      try {
        const res = await axios.get("/bis");
        this.dataTableItems = res.data.map((ticket) => ({
          ...ticket,
          is_read: ticket.is_read || 0, // Ensure is_read is set to 0 if undefined
          firstname: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].firstname || '' 
            : '', // Extract firstname from first item in ticket_bis array
          lastname: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].lastname || '' 
            : '', // Extract lastname from first item in ticket_bis array
          buyer_name: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? `${ticket.ticket_bis[0].firstname || ''} ${ticket.ticket_bis[0].lastname || ''}`.trim() 
            : '', // Concatenate firstname and lastname for buyer_name
          contractNumber: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].contract_number || '' 
            : '', // Extract contract_number from first item in ticket_bis array
          // New fields
          ticket_number: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].ticket_number || '' 
            : '', // Extract ticket_number
          subject: ticket.subject || '', // Use existing subject or empty string
          reg_date: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].reg_date || '' 
            : '', // Extract reg_date
          block: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].block || '' 
            : '', // Extract block
          floor: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].floor || '' 
            : '', // Extract floor
          phase: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].phase || '' 
            : '', // Extract phase
          project: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].project || '' 
            : '', // Extract project
          building: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].building || '' 
            : '', // Extract building
          co_lastname: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].co_lastname || '' 
            : '', // Extract co_lastname
          co_firstname: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].co_firstname || '' 
            : '', // Extract co_firstname
          email: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].email || '' 
            : '', // Extract email
          mobile: Array.isArray(ticket.ticket_bis) && ticket.ticket_bis.length > 0 
            ? ticket.ticket_bis[0].mobile || '' 
            : '', // Extract mobile
          attachments: {
            attachment1: `${ticket.id1_filepath}`,
            attachment2: `${ticket.id1_filepath}`,
            attachment3: `${ticket.id1_filepath}`,
          },
          classification:"BIS"
        }));
        this.markedRows = this.dataTableItems
          .filter((ticket) => ticket.is_read === 1)
          .map((ticket) => ticket.ticket_id);
        this.endProgress();
      } catch (error) {
        this.endProgress();
        console.error("Error fetching BIS tickets:", error);
      }
    },
    async getTickets() {
      try {
        this.startProgress();
        const res = await axios.get("/tickets/unassigned");
        this.dataTableItems = res.data.map((ticket) => ({
          ...ticket,
          is_read: ticket.is_read || 0, // Ensure is_read is set to 0 if undefined
        }));
        // Populate markedRows based on is_read
        this.markedRows = this.dataTableItems
          .filter((ticket) => ticket.is_read === 1)
          .map((ticket) => ticket.ticket_id);
        this.endProgress();
      } catch (error) {
        this.endProgress();
        console.error("Error fetching tickets:", error);
      }
    },
    async getWatchList() {
      this.startProgress();
      try {
        const res = await axios.get("/tickets/watchlist");
        this.dataTableItems = res.data;
        this.endProgress();
      } catch (e) {
        this.endProgress();
      }
    },
    postTickets(n) {
      this.startProgress();
      let data = {
        department_id: n,
      };
      axios.post("/tickets/get-assigned", data).then((res) => {
        this.dataTableItems = res.data;
        this.endProgress();
      }).catch(() => this.endProgress());
    },
  },
};
</script>

<style>
.MenuWrapper {
  background: rgb(35, 35, 35);
  background: linear-gradient(
    156deg,
    rgba(35, 35, 35, 1) 0%,
    rgba(8, 133, 42, 1) 58%,
    rgba(62, 160, 89, 1) 76%,
    rgba(101, 179, 122, 1) 92%
  );
}
.buttons {
  background: rgb(72, 72, 72);
  background: linear-gradient(
    156deg,
    rgba(72, 72, 72, 1) 37%,
    rgba(117, 117, 117, 1) 77%
  );
}

.marked-circle {
  background-color: black;
  color: white;
}

.unmarked-circle {
  background-color: transparent;
  color: black;
}

.no-data-table-rows-hover .v-data-table__wrapper tbody tr:hover {
  background-color: transparent !important;
}

.textStyle {
  color: white !important;
}
</style>
